// extracted by mini-css-extract-plugin
export default {"light":"styles_light__X9H5d","mobileButtonWrapper":"styles_mobileButtonWrapper__xiAFz","menuButton":"styles_menuButton__ZmlY4","menuModal":"styles_menuModal__JBxXU"};